// eslint-disable-next-line no-unused-vars
import { SessionStorageKeys, UserLicenseNames } from '@enums/index';
import { safeJsonParse } from '@commonClient2/services/json';

/** @typedef {typeof UserLicenseNames} ILicense */

export const getJwtUserInfo = () => {
    const userInfoStringified = sessionStorage.getItem(SessionStorageKeys.jwtUserInfo);

    if (!userInfoStringified) {
        return null;
    }

    /** @type {JsonWebToken.IUserInfo} */
    const userInfo = safeJsonParse(userInfoStringified);
    return userInfo;
};

/**
 * Checks if user has some specific license
 * @param {ILicense[keyof ILicense]|string[]} license A license or a specific collection of licenses to be checked
 */
export const hasLicense = (license) => {
    if (Array.isArray(license)) {
        return !!getJwtUserInfo()?.Licenses?.every((x) => license.includes(x));
    }

    return !!getJwtUserInfo()?.Licenses?.includes(license);
};

export const getUserLicenses = () => getJwtUserInfo()?.Licenses || [];
